let featureFlags = {}

const getFlag = flag => !!featureFlags[flag]

const setFlags = newFeatureFlags => {
	featureFlags = {
		...featureFlags,
		...newFeatureFlags,
	}
}

export {
	setFlags,
	getFlag,
}
